import React, { useState } from "react";
import { apiUrl } from "../../config";
import { toast } from "react-toastify";
const ContactForm = () => {
  const formDataMock = {
    sender: "",
    subject: "",
    message: "",
    name: "",
    phone: "",
  }
  const [formData, setFormData] = useState(formDataMock);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const myHeaders = new Headers();
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify(formData),
    };

    fetch(`${apiUrl}/support-message`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          setFormData(formDataMock)
          toast.success("Message succesfully sent");
        }
      })
      .catch((error) => toast.error(error.message));
  };
  return (
    <div className="p-4">
      <div className="row">
        <div
          className="get-started section-padding"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="col-12 col-md-6">
            <form onSubmit={handleSubmit}>
              <h3 style={{ color: "black" }}>
                Still need help? Drop Us a Message
              </h3>
              <div className="row">
                <div className="col-6">
                  <div className="form-group py-2">
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group py-2">
                    <input
                      type="email"
                      name="sender"
                      className="form-control"
                      placeholder="Your Email *"
                      value={formData.sender}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group py-2">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your name *"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group py-2">
                    <input
                      type="text"
                      name="phone"
                      className="form-control"
                      placeholder="Your phone *"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group py-2">
                    <textarea
                      name="message"
                      className="form-control"
                      placeholder="Your Message *"
                      value={formData.message}
                      onChange={handleInputChange}
                      style={{ minHeight: "200px" }}
                    ></textarea>
                  </div>
                  <div className="form-group py-4">
                    <input
                      type="submit"
                      name="btnSubmit"
                      className="btn btn-primary"
                      value="Send Message"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
